import MembersService from '../services/members.service';

export const members = {
  namespaced: true,
  state: {
    memberGetMemberReferrals: [],
    memberGetMemberPendingInvites: [],
    memberGetMemberReferralsLoading: false,
  },
  mutations: {
    setMemberGetMemberReferrals(state, referrals) {
      state.memberGetMemberReferrals = referrals || [];
    },
    setMemberGetMemberPendingInvites(state, pending) {
      state.memberGetMemberPendingInvites = pending || [];
    },
    setMemberGetMemberReferralsLoading(state, loading) {
      state.memberGetMemberReferralsLoading = !!loading;
    },
  },
  actions: {
    update({ commit }, { memberId, body }) {
      return MembersService.update(memberId, body);
    },
    updateMemberAvatar({ commit }, { memberId, body }) {
      return MembersService.updateMemberAvatar(memberId, body);
    },
    acceptRegulation({ commit }, { body }) {
      return MembersService.acceptRegulation(body);
    },
    fetchMemberGetMemberReferrals({ commit }) {
      commit('setMemberGetMemberReferralsLoading', true);
      return MembersService.getMemberGetMember()
        .then((resp) => {
          commit('setMemberGetMemberReferrals', resp.data?.referrals || []);
          commit('setMemberGetMemberPendingInvites', resp.data?.pendingInvites || []);
        })
        .catch(() => {
          commit('setMemberGetMemberReferrals', []);
          commit('setMemberGetMemberPendingInvites', []);
        })
        .finally(() => {
          commit('setMemberGetMemberReferralsLoading', false);
        });
    },
  },
};
